import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main'
import user from './modules/user'
import component from "./modules/component";
import getters from './getters.js'
import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    main,
    user,
    component
  },
  getters,
  plugins: [
    createPersistedstate({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.sessionStorage,
      key: 'nwt_store',
      paths: ['main']
    }),
    createPersistedstate({
      storage: window.localStorage,  // 使用 localStorage
      key: 'userInfo',  // 指定存储的键为 userInfo
      paths: ['user']
    }),
    createPersistedstate({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.localStorage,
      key: 'nwt_component',
      paths: ['component']
    })
  ]
})
